import { render, staticRenderFns } from "./multipay.vue?vue&type=template&id=3c7f2649&"
import script from "./multipay.vue?vue&type=script&lang=js&"
export * from "./multipay.vue?vue&type=script&lang=js&"
import style0 from "./multipay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports